import { render, staticRenderFns } from "./ModattaNavbar.vue?vue&type=template&id=3746515e&scoped=true"
import script from "./ModattaNavbar.vue?vue&type=script&lang=js"
export * from "./ModattaNavbar.vue?vue&type=script&lang=js"
import style0 from "./ModattaNavbar.vue?vue&type=style&index=0&id=3746515e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3746515e",
  null
  
)

export default component.exports